import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormGroup, FormsModule, ReactiveFormsModule, FormControl, FormArray } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Subject, BehaviorSubject, Subscription, tap, switchMap } from 'rxjs';


// Services
import { ValuesService } from '@app/common/values/values.service';
import { CommonService } from '@app/common/common.service';
import * as constants from "@app/shared/constants";

// Models
import * as common from '@app/shared/_models/common';
import { TreeNode } from '@app/shared/_models/common';

// Components
import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component';
import { SearchPartnerComponent } from '@app/shared/search-partner/search-partner.component';
import { PartnerComponent } from '@app/common/partner/partner.component';
import { ImageViewerDialogComponent } from '@app/shared/attach/image-viewer-dialog/image-viewer-dialog.component';
import { TreeComponent } from '../tree/tree.component';
import { ProductTplService } from '../productTpl.service';
import { PARTNER_ROLE_MANUFACTURER, PARTNER_ROLE_SUPPLIER } from '@app/shared/constants';

@Component({
    selector: 'app-product-tpl-general',
    templateUrl: './product-tpl-general.component.html',
    styleUrls: ['./product-tpl-general.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatIconModule, MatButtonModule, MatDialogModule, RouterLink, SmartSelectComponent, SearchPartnerComponent]
})
export class ProductTplGeneralComponent {
[x: string]: any;
	/** Rôles des deux sélecteurs de tiers du gabarit (c_values 2, ids négatifs depuis le 2026-09-15). */
	readonly ROLE_MANUFACTURER = PARTNER_ROLE_MANUFACTURER;
	readonly ROLE_SUPPLIER = PARTNER_ROLE_SUPPLIER;
	// @Input() is_flatProduct: boolean = false;
	@Input() canEditGeneral: boolean = true;
// 3 cas :
//     Si on a affaire à un produit à plat : is_flatProduct=true et canEditGeneral=true car c'est la seule interface d'accès.
//     Si on est sur un template : is_flatProduct=false et canEditGeneral=true, c'est l'interface d'édition des TemplateAttribute.
//     Si on est sur un spécifique : is_flatProduct=false et canEditGeneral=false. On voit les infos du template mais surtout on ne peut pas les modifier car cela les modifierait pour tous les autres spécifiques de ce template.

// Nouveaux Inputs nécessaires pour l'affichage déplacé
  // @Input() tree: common.TreeNode | undefined;
  // @Input() selectedTreeNode: Set<TreeNode> = new Set<TreeNode>();
  @Input() attachs_images: common.Attach[] = [];

  // Outputs pour les actions qui nécessitent une logique coté parent (ex: rechargement de page / API spécifique)
  // @Output() supplierAdd = new EventEmitter<common.Partner>();
  // @Output() supplierRemove = new EventEmitter<common.Partner>();
  @Output() reload = new EventEmitter<number> ();
  @Output() treeSelectionChange = new EventEmitter<Set<TreeNode>>();


	public salesUnit:any;
	public vat:any;
  private templateServiceSubscription!: Subscription;
  

  // Getter pour toujours récupérer le FormGroup courant du parent
  get pformGroup(): FormGroup {
    return this.controlContainer.control as FormGroup
  }

  
	
  public trees = new Map<string, common.TreeNode>();
  public selectedTreeNode = new Set<TreeNode>();

  private  prefixTree = ['princ', 'config'];

	constructor( private productTplService: ProductTplService,  private valuesService: ValuesService, private commonService: CommonService, public controlContainer: ControlContainer   , public dialog: MatDialog) { }

ngOnInit(): void {
  if( ! this.canEditGeneral) {
    this.pformGroup.disable();
  }

    // pformGroup est maintenant un getter, pas besoin d'assignation
    console.log('this.pformGroup',this.pformGroup.value);
    this.valuesService.getValues$(constants.C_VALUES_UOM)
      .subscribe((data: any) => {
        // this.salesUnit = data.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.salesUnit = data;
      });

    this.commonService.getTaxes()
      .subscribe((data: any) => {
        this.vat = data;
      });
      
    for (const prefix of this.prefixTree) {
      this.commonService.getTree(prefix, 0).subscribe((items: common.ITreeNode[]) => {
        const root = new common.TreeNode({ id: 0, seq: 0, name: 'Root', label: 'Root', path: '', nlevel: 0, typ: 0, children: [] });
        items.sort((a, b) => a.path.length - b.path.length);
        items.forEach(item => {
          root.getNodeByPath(item.path.split('.').slice(0, -1))?.children.push(new common.TreeNode(item));
        });
        this.trees.set(prefix, root);
      });
    }

    this.selectedTreeNode = this.pformGroup.value.lnk_treenodes ? new Set<TreeNode>(this.pformGroup.value.lnk_treenodes) : new Set<TreeNode>()  // Initialisation de
  }

  openTreeDialog(treePrefix: string): void {
    const tree = this.trees.get(treePrefix);
    if (!tree || !tree.children?.length) return;

    this.dialog.open(TreeComponent, {
      data: {
        tree: tree.children[0],
        selected: this.selectedTreeNode,
        selectedChange: (selected: Set<TreeNode>) => this.onSelectedChange(selected),
        treePrefix  : treePrefix,
        singleSelect : true
      },
      width: '600px',
    });
  }

  onSelectedChange(selectedTreeNode : Set<TreeNode>) {
    console.log('begening selectedTreeNode',selectedTreeNode);
    this.selectedTreeNode = selectedTreeNode;

    this.pformGroup.setControl('lnk_treenodes', new FormArray(
      Array.from(selectedTreeNode).map((tn: TreeNode) => TreeNode.asFormGroup(tn))
    ));

    console.log('end selectedTreeNode',selectedTreeNode);
  }


















  // --- Logique déplacée depuis ProductTplComponent ---

  get defaultMemoControl(): FormControl | null {
    if (!this.pformGroup) return null;
    const lnk_Attachs = this.pformGroup.get('lnk_attachs') as FormArray;
    if (!lnk_Attachs) return null;

    const index = lnk_Attachs.controls.findIndex((ctrl) => {
      const data = ctrl.get('data')?.value;
      return data?.flags?.includes('is_default_memo');
    });
    if (index === -1) return null;
    return lnk_Attachs.at(index).get('memo') as FormControl;
  }

  get defaultImage(): common.Attach | undefined {
    return this.attachs_images.find(a => a.data?.['flags']?.includes('is_default_image'));
  }

  manufactureChange(newManufacture: common.Partner) {
    console.log('newManufacture', newManufacture);
    if (newManufacture && newManufacture.id) {
      this.pformGroup.get("manuf")?.patchValue(newManufacture.id);
      this.pformGroup.setControl('lnk_partner_manuf', common.Partner.asFormGroup(newManufacture));
    } else {
      this.pformGroup.setControl('lnk_partner_manuf', null);
      this.pformGroup.get("manuf")?.patchValue(undefined);
    }
  }

  openPartnerDialog(idpartner: Number) {
    const dialogRef = this.dialog.open(PartnerComponent, {
      width: '80%',
      height: '80%',
      data: { mode: "DIALOG", "id": idpartner }
    });
    dialogRef.afterClosed().subscribe((newpartner) => {
      // Si c'est pour le fabricant (appelé depuis le lien fabricant)
      if(newpartner) this.manufactureChange(newpartner);
    });
  }



  addSupplier(newSupplier: common.Partner) {
    // this.supplierAdd.emit(newSupplier);
    if(this.pformGroup.value.id){
      console.log('newSupplier',newSupplier);
     this.templateServiceSubscription = this.productTplService.postAddSupplierToTemplate(newSupplier.id, this.pformGroup.value.id ).subscribe((response: any) => {
     console.log("Server response: " + JSON.stringify(response));
     // this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
     this.reload.emit()
 });
    }
  }

  removeSupplier(oldSupplier: common.Partner) {
    // this.supplierRemove.emit(oldSupplier);
    if(this.pformGroup.value.id){
     console.log('Salut from : inside remove supplier dans productTpl');
        this.templateServiceSubscription = this.productTplService.postRemoveSupplierToTemplate(oldSupplier.id, this.pformGroup.value.id ).subscribe((response: any) => {
          console.log("Server response: " + JSON.stringify(response));
          // this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
          this.reload.emit()

        });	
  }
  }


      // addSupplier(newSupplier: common.Partner){
      //   console.log('newSupplier',newSupplier);
      //   this.productServiceSubscription = this.productTplService.postAddSupplierToTemplate(newSupplier.id, this.template_id ).subscribe((response: any) => {
      //   console.log("Server response: " + JSON.stringify(response));
      //   this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
      // });	
  
      // }
  
      // removeSupplier(oldSupplier: common.Partner){
      //   console.log('Salut from : inside remove supplier dans productTpl');
      //   this.productServiceSubscription = this.productTplService.postRemoveSupplierToTemplate(oldSupplier.id, this.template_id ).subscribe((response: any) => {
      //     console.log("Server response: " + JSON.stringify(response));
      //     this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
      //   });	
      // }

  tva_change(id: number) {
    const selected = this.vat.find((v: any) => v.id === id);
    if (selected) {
      this.pformGroup.get('vat_rate')?.patchValue(selected.rate);
    }
    this.reload.emit();
  }


  onImageClick() {
    if (!this.defaultImage) return;
    this.dialog.open(ImageViewerDialogComponent, {
      width: '90%',
      maxWidth: '1200px',
      maxHeight: '90vh',
      data: { attach: this.defaultImage },
      panelClass: 'image-viewer-dialog-panel'
    });
  }
}